import React from 'react';
import clsx from 'clsx';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import { useWindowSize } from 'hooks/breakpoints';
import styles from './Modal.module.scss';

export type ModalProps = Exclude<ReactModalProps, 'overlayClassName'> & {
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

// Bind the modal to the root appElement (http://reactcommunity.org/react-modal/accessibility/)
// Check if it exists first so unit tests don't try to bind to root
if (document.getElementById('root')) ReactModal.setAppElement('#root');

export const Modal: React.FC<ModalProps> = (props) => {
  const { onClose, className, bodyOpenClassName, children, ...passthroughProps } = props;
  const [coords, setCoords] = React.useState({ x: 0, y: 0 });

  const { isDesktop } = useWindowSize();

  const spreadProps: Partial<ModalProps> = {};
  // Prevent 'Warning: react-modal: App element is not defined.' during unit testing
  if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line
    spreadProps.ariaHideApp = false;
  }

  const handleAfterOpenFunc = () => {
    setCoords(prevCoords => Object.assign({}, prevCoords, { x: window.scrollX, y: window.scrollY }));
    // eslint-disable-next-line functional/immutable-data
    document.getElementsByTagName('body')[0].style.position = 'fixed';
  };

  const handleAfterCloseFunc = () => {
    // eslint-disable-next-line functional/immutable-data
    document.getElementsByTagName('body')[0].style.position = '';
    window.scrollTo(coords.x, coords.y);
  };

  return (
    <ReactModal
      onAfterOpen={!isDesktop ? handleAfterOpenFunc : undefined}
      onAfterClose={!isDesktop ? handleAfterCloseFunc : undefined}
      aria={{ modal: true }}
      className={clsx(styles.modal, className)}
      overlayClassName={styles.overlay}
      bodyOpenClassName={clsx(styles.bodyWithoutScroll, bodyOpenClassName)}
      onRequestClose={onClose}
      {...spreadProps}
      {...passthroughProps}
    >
      {children}
    </ReactModal>
  );
};
